import { uniq } from "lodash";
import { useMemo } from "react";
import useGetFartherManagedAccounts from "../../Accounts/hooks/useGetFartherManagedAccounts";
import lastDateForCustodianData from "../utilities/lastDateForCustodianData";
const useLastDateForCustodianData = (personId, authConfig) => {
    const accounts = useGetFartherManagedAccounts(personId, authConfig);
    const data = useMemo(() => {
        if (accounts.isLoading || accounts.hasError) {
            return accounts;
        }
        const custodians = uniq(accounts.data?.map((a) => a.accountDetails.custodian));
        const hasApex = custodians.includes("Apex");
        const today = new Date();
        return {
            data: lastDateForCustodianData(today, hasApex),
            isLoading: false,
            hasError: false,
        };
    }, [accounts]);
    return data;
};
export default useLastDateForCustodianData;
//# sourceMappingURL=useLastDateForCustodianData.js.map